export default "__VITE_ASSET__CtDz7loA__"